module.exports = {
    // basic
    'rig': 'rig',
    'rigs': 'rigs',
    'a-rig': 'a rig',
    'reset-filters': 'reset filters',
    'filters': 'filters',
    'reset': 'reset',
    'show-all': 'show all',
    'yes': 'yes',
    'no': 'no',
    'on': 'on',
    'off': 'off',
    'add': 'add',
    'edit': 'edit',
    'all': 'all',
    'selected': 'selected',
    'delete': 'delete',
    'delete-all': 'delete all',
    'delete-selected': 'delete selected',
    'download': 'download',
    'download-all': 'download all',
    'download-selected': 'download selected',
    'export': 'export',
    'open': 'open',
    'close': 'close',
    'menu': 'menu',
    'mon': 'mon',
    'tue': 'tue',
    'wed': 'wed',
    'thu': 'thu',
    'fri': 'fri',
    'sat': 'sat',
    'sun': 'sun',
    'time-zone': 'time zone',
    'a-time-zone': 'a time zone',
    'save': 'save',
    'ok': 'ok',
    'cancel': 'cancel',
    'company': 'company',
    'companies': 'companies',
    'a-company': 'a company',
    'asset': 'asset',
    'assets': 'assets',
    'an-asset': 'an asset',
    'pad': 'pad',
    'pads': 'pads',
    'a-pad': 'a pad',
    'state': 'state',
    'states': 'states',
    'a-state': 'a state',
    'field': 'field',
    'fields': 'fields',
    'a-field': 'a field',
    'country': 'country',
    'countries': 'countries',
    'a-country': 'a country',
    'well': 'well',
    'wells': 'wells',
    'a-well': 'a well',
    'column-options': 'column options',
    'drilling': 'drilling',
    'completion': 'completion',
    'flowback': 'flowback',
    'audited': 'audited',
    'legalHold': 'legal hold',
    'workover': 'workover',
    'production': 'production',
    'any': 'any',
    'apply-filters': 'apply filters',
    'well-stage': 'well stage',
    'a-well-stage': 'a well stage',
    'start': 'start',
    'end': 'end',
    'date': 'date',
    'entry-type': 'entry type',
    'rejected': 'rejected',
    'approved': 'approved',
    'template': 'template',
    'mobile': 'mobile',
    'hours': 'hours',
    'days': 'days',
    'new': 'new',
    'a-company-to-view-wells': 'a company to view wells',
    'a-company-to-view-entry-types': 'a company to view entry types',
    'entry-type-to-view-doc-approval-steps': 'an entry type to view approval steps',
    'well-property': 'well property',
    'well-properties': 'well properties',
    'a-well-property': 'a well property',
    'column': 'column',
    'a-column': 'a column',
    'select': 'select',
    'a-saved-search': 'a saved search',
    'an-entry-type': 'an entry type',
    'entry-types': 'entry types',
    'include-pending-entries': 'Include Entries Pending Approval',
    'username': 'username',
    'uploaded-by': 'uploaded by',
    'uploaded-on': 'uploaded on',
    'files': 'files',
    'size': 'size',
    'sticky': 'keep entry highlighted at the top of the list',
    'dont-send-alerts': 'do not send alerts',
    'email': 'email',
    'filename': 'filename',
    'name': 'name',
    'upload-date': 'upload date',
    'preserve-upload-date': 'preserve upload date',
    'approval-status': 'approval status',
    'remarks': 'remarks',
    'approved-by': 'approved by',
    'approval-date': 'approval date',
    'approve': 'approve',
    'reject': 'reject',
    'search-by': 'search by',
    'additional-columns': 'additional columns',
    'spud-date': 'spud date',
    'add-date': 'add date',
    'elevation': 'elevation',
    'projected-depth': 'projected depth',
    'a-template': 'a template',
    'approvals': 'approvals',
    'department-or-role': 'Department Or Role',
    'approval-steps': 'approval steps',
    'an-entry-type-group': 'an entry type group',
    'entry-type-group': 'entry type group',
    'user': 'user',
    'users': 'users',
    'entries': 'entries',
    'upload': 'upload',
    'access-review': 'access review',
    'entry-audit': 'entry audit',
    'notifications': 'notifications',
    'search': 'search',
    'doc-approval-search': 'document approval search',
    'report': 'report',
    'all-reports': 'all reports',
    'reports-i-created': 'reports i created',
    'reports-i-receive': 'reports i receive',
    'my-account': 'my account',
    'recycle-bin': 'recycle bin',
    'help': 'help',
    'succeeded': 'succeeded',
    'failed': 'failed',
    'saved': 'saved',
    'first-name': 'first name',
    'last-name': 'last name',
    'email-address': 'email address',
    'a-cell-carrier': 'a cell carrier',
    'cell-carrier': 'cell carrier',
    'cell-phone': 'cell phone',
    'office-phone': 'office phone',
    'address': 'address',
    'city': 'city',
    'province': 'province / region',
    'grouping-preference': 'use group by entry type view by default',
    'wells-per-page': 'wells per page',
    'language': 'language',
    'password': 'password',
    'confirm-password': 'confirm password',
    'files-per-entry': 'files per entry',
    'columns': 'columns',
    'save-search': 'save search',
    'search-name': 'search name',
    'session-expired': 'your session has expired',
    'session-expiring': 'your session is about to time out',
    'role': 'role',
    '404-home': 'take me home',
    '404-support': 'contact support',
    'months': 'months',
    'limits': 'limits',
    'edited': 'edited',
    'edit-date': 'edit date',
    'edited-by': 'edited by',
    'select-all': 'select all',
    'preview': 'preview',
    'last-24-hours': 'last 24 hours',
    'last-login': 'last login',
    'international': 'international',
    'change-password': 'change password',
    'actions': 'actions',
    'well-header-info': 'well header info',
    'added': 'added',
    'added-by': 'added by',
    'prod-data': 'production data',
    'no-change': '- No change -',
    'county': 'county',
    'counties': 'counties',
    'a-county': 'a county',
    'check-all': 'check all',
    //// sidebar only
    'entry-type-access': 'entry type access',
    'my-company': 'my company',
    'reports': 'reports',
    'sign-out': 'sign out',
    'home': 'home',

    // raw
    'entry-type-required': 'Please select an entry type.',
    'wellbore-audit-template-required': 'Please select a well audit template.',
    'time-zone-required': 'Please select a time zone.',
    'company-required': 'Please select a company.',
    'no-pdf-selected': 'No PDF files exist in the selected entries.',
    'no-pdf-found': 'No PDF files were found.',
    'unable-reach-server': 'Unable to reach server.',
    'enter-username': 'Please enter a user name.',
    'enter-password': 'Please enter a password.',
    'enter-password-confirm': 'You must confirm your password.',
    'first-name-empty': 'You must enter a first name.',
    'last-name-empty': 'You must enter a last name.',
    'enter-valid-phone-number': 'Please enter a valid phone number.',
    'enter-valid-nonusa-phone-number': 'Please enter a valid International phone number.',
    'validate-select-entry-type': 'You must select an entry type.',
    'enter-valid-email': 'Please enter a valid email address.',
    'doc-approval-report-pending-all-help': 'Show entries still pending approval for all steps ("new" entries).',
    'doc-approval-report-pending-selected-help': 'Show entries still pending approval for the selected steps.',
    'doc-approval-report-pending-any-help': 'Show entries still pending approval for any step.',
    'doc-approval-report-rejected-status-help': 'Show entries that have been rejected, regardless of any approved steps.',
    'doc-approval-report-approved-status-help': 'Show entries that have all steps approved.',
    'doc-approval-report-pending-status-help': 'Show entries that still have pending approvals.',
    'doc-approval-report-any-status-help': 'Please make a selection in <b>Approval Status.</b>',
    'error-404-general': 'Sorry, an error has occured. Requested page not found.',
    'download-fail': 'Download failed.',
    'no-selection': 'Nothing selected.',
    'start-date-less-than-end-date': 'Start Date must be less than or equal to End Date',
    'date-panel-help': `
        <p class="h4">
            Range
        </p>
        <div class="alert alert-warning">
            <dl class="help-definition-list">
                <dt>
                    Any date
                </dt>
                <dd>
                    Leave both boxes blank.
                </dd>
                <dt>
                    Exact date
                </dt>
                <dd>
                    Enter same value in both <b>Start</b> and <b>End</b>.
                </dd>
                <dt>
                    Before a date
                </dt>
                <dd>
                    Enter only <b>End</b> value.
                </dd>
                <dt>
                    After a date
                </dt>
                <dd>
                    Enter only <b>Start</b> value.
                </dd>
                <dt>
                    Between two dates
                </dt>
                <dd>
                    Enter different values in both <b>Start</b> and <b>End</b>.
            </dl>
        </div>
    `,
    'grid-no-items': 'No items to display',
    'filter-collapse': 'Choose from the filter conditions, below, then click <b>Apply Filters</b>. Click <b>Clear Filters</b> at any time to remove all filters.',
    'grid-items-per-page': 'items per page',
    'session-expired-continue': `Click <b>Ok</b> to return to the sign in page.`,
    'session-timeout-status': 'Your session will end in',
    'session-continue': `Click <b>Ok</b> to continue your current session.`,
    'tbd': 'TBD',
    'not-tbd': 'Not TBD',
    'combined-pdf': 'Combined PDF',
    'usa': 'USA',
    'user-time-zone-help': `
        <b>Time Zone</b> selection will affect date and time selections in search criteria, as well as scheduling, on pages that contain those features, where noted. If present, time zone options on any individual page will override this setting.<br />
        The default time zone is CST.
    `,
    'group-name-required': `Please enter a group name.`,
    'status-required': `Please select a status.`,
    'insufficient-permissions': 'There was a problem with your account. Please contact WellDrive Operations at <a href="tel:+1877704827">(877) 704-827</a> or email them at <a href="mailto:ops@welldrive.com">ops@welldrive.com</a> for assistance.',
    'legal-hold-yes': 'Legal Hold enabled.',
    'legal-hold-no': 'Legal Hold disabled.',
    'legal-hold-error': 'Error trying to enable Legal Hold.',

    // template
    // Special Kendo-only template.
    'grid-item-count': '{0} - {1} of {2} items',
    'cell-carrier-required-if-cell-number': (words) => `<b>${words[0]}</b> must have a selection if <b>${words[1]}</b> is not empty.`,
    'cell-number-required-if-cell-carrier': (words) => `<b>${words[0]}</b> must not be empty if <b>${words[1]}</b> is not empty.`,
    'session-timeout-explain': (words) => `As a security precaution, sessions end after ${words[0]} minutes of inactivity.`,
    'less-than-number-of-characters': (words) => `${words[0]} should be less than ${words[1]} characters.`,
    'corrupt-pdf': (words) => `Could not add file "${words[0]}" to combined PDF. Please make sure the file is not corrupt.`,
    'download-too-big': (words) => `The total size of the file(s) you are trying to download exceeds the limit of ${words[0]} MB.  Please change your selection and try again, or contact WellDrive Operations for assistance.`,
    'confirm-delete-saved-search': (words) => `This will delete saved search "${words[0]}".\n\nContinue?`,

};
